<template>
  <div :key="pageKey">
    <SPreloader />
    <!-- ... end Responsive Header-BP -->
    <SSubHeader :pageName="'Group page'" :backButton="true" />
    <div class="header-spacer"></div>
    <HeaderGroup :group="getCurrentGroup" :isHidden="isHidden()" :joinBtnResend="joinBtnDisabled"/>

    <div class="container d-flex flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row ">

      <!-- LEFT BAR -->
      <div class="left-bar col col-lg-3 col-xl-2 no-padding" v-if="showAbout">
        <LeftSideBarGroup :group="getCurrentGroup" :canSee="canSee" :joinBtnVisible="joinGroupBtnVisible" :joinBtnDisabled="joinBtnDisabled" />
      </div>

      <!-- MAIN CONTENT -->
      <div class="d-flex w-100 justify-content-between">
        <!-- MAIN CONTENT -->
          <router-view :group="getCurrentGroup" v-if="canSee"></router-view>
          <div v-if="joinGroupBtnVisible === 'private_non_member'" class="private-group-message">
            <img src="../../public/svg-icons/lock-icon.svg" alt="Private group">
            <p>Only members can view the content of this private group.</p>
            <SButtonJoinGroup v-if="!joinBtnDisabled" dataCy="btnJoinGroup_grouPage" :data-cy="getCurrentGroup.name" text="ASK TO JOIN"
            icon="add_box" svgIcon="" color="secondary" textColor="white" @setAction="openModal" :disabled="joinBtnDisabled" />
            <SButtonJoinGroup v-if="joinBtnDisabled" dataCy="btnJoinGroup_grouPage" :data-cy="getCurrentGroup.name" text="RESEND REQUEST"
            icon="add_box" svgIcon="" color="darker-grey" textColor="white" @setAction="openModal" />
            <span v-if="joinBtnDisabled" class="waiting-approval-text">You have requested to join this group (waiting for moderator's approval)</span>
          </div>

       <!-- RIGHT BAR -->
        <div class="right-bar col col-lg-7 col-xl-7 no-padding" v-if="canSee && !isSettingsTab">
            <RightSideBarGroup :canSee="canSee && !isSettingsTab" />
        </div>
      </div>
    </div>
      <a class="back-to-top arrow-top" href="#" v-if="pageBottom">
        <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
      </a>
      <Footer/>
  </div>
</template>
<script>
import HeaderGroup from "@/components/organisms/HeaderGroup";
import LeftSideBarGroup from "@/components/organisms/LeftSideBarGroup";
import GroupHelper from "@/mixins/GroupHelper";
import RightSideBarGroup from "@/components/organisms/RightSideBarGroup";
import SPreloader from "@/components/organisms/SPreloader.vue";
import groupPrivacy from "@/enum/group-privacy";
import UserHelperVue from "../mixins/UserHelper.vue";
import store from "@/vuex/store";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import SButtonJoinGroup from '../material-components/molecules/SButtonJoinGroup.vue';
import { getCurrentGroup } from '../vuex/modules/groups/getters';
import Footer from "@/templates/Footer";

export default {
  name: "GroupPage",
  components: {
    HeaderGroup,
    LeftSideBarGroup,
    SPreloader,
    SSubHeader,
    SButtonJoinGroup,
    RightSideBarGroup,
    Footer,
  },
  data() {
    return {
      pageKey: 0,
      joinBtnDisabled: false,
      showAbout: false
    };
  },
  mixins: [GroupHelper, UserHelperVue],
  computed: {
    canSee() {
      if (
        groupPrivacy.PRIVATE === this.getCurrentGroup.privacy ||
        groupPrivacy.HIDDEN === this.getCurrentGroup.privacy
      ) {
        let myGroup = this.getCurrentGroupMembers.find(
          (g) => g.sUserId == this.loggedUser.id
        );
        return myGroup ? true : false;
      } else {
        return true;
      }
    },
    isSettingsTab() {
      return this.$route.name === "GroupSettings";
    },
    joinGroupBtnVisible() {
      let myGroup = this.getCurrentGroupMembers.find(
        (g) => g.sUserId == this.loggedUser.id
      );
      let returnedValue;
      if (groupPrivacy.PRIVATE === this.getCurrentGroup.privacy && !myGroup)
        returnedValue = "private_non_member";
      if (groupPrivacy.PUBLIC === this.getCurrentGroup.privacy && !myGroup)
        returnedValue = "public_non_member";

      return returnedValue;
    },
  },
  methods: {
    setupGroupPage() {
      this.fetchGroup(this.$route.params.id);
      this.fetchMembers(this.$route.params.id);
      this.fetchItems(this.$route.params.id);
      this.fetchMessages(this.$route.params.id);
      this.fetchJoinRequests(this.$route.params.id);
    },
    isHidden() {
      return groupPrivacy.HIDDEN === this.getCurrentGroup.privacy
        ? true
        : false;
    },
    openModal() {
      if (getCurrentGroup.privacy === groupPrivacy.PUBLIC) {
        this.joinGroup({ groupId: this.group.id, groupName: this.group.name });
      } else {
        $("#join-request").modal("show");
      }
    },
    handleResize() {
      this.showAbout = window.innerWidth > 1024;
    }
  },
  watch: {
    async $route(to, from) {
      if (to.params !== from.params) {
        this.setupGroupPage();
        this.joinBtnDisabled = this.getMyJoinRequests.some((req) => req.groupId === +to.params.id);
      }
    },
  },
  mounted() {
    this.showAbout = window.innerWidth > 1024;
    window.addEventListener('resize', this.handleResize);
  },
  async beforeRouteEnter(to, _, next) {
    await store.dispatch("getMyGroups");
    await store.dispatch("validateGroupId", to.params.id);
    const validGroupResponse = store.getters["getValidGroupResponse"];
    const myGroups = store.getters["getMyGroups"];
    setTimeout(() => {
      if (!validGroupResponse.error) {
        if (groupPrivacy.HIDDEN === validGroupResponse.privacy) {
          if (
            myGroups.some((group) => group.groupId === validGroupResponse.id)
          ) {
            next();
          } else {
            next("/s-app/feed");
          }
        } else {
          next();
        }
      } else {
        next("/s-app/feed");
      }
    }, 1001);
  },
  async created() {
    this.setupGroupPage();
    await this.fetchMyJoinRequests();
    this.joinBtnDisabled = this.getMyJoinRequests.some((req) => req.groupId === +this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.pageKey += 1;
    this.resetCurrentGroup();
    next();
  },
};
</script>

<style scoped>

.container {
  max-width: 1628px;
  padding: 0 64px;
  margin: auto !important;
}

.right-bar {
  margin-left: 8px;
  min-width: 260px;
  max-width: 300px;
}
.left-bar {
  flex: unset;
  margin-right: 8px;
  min-width: 224px;
  max-width: 224px;
}
.about-group {
  padding: 0px 15px;
  flex: 0 0 25%;
  max-width: 25%;
}
.waiting-approval-text {
  color: red;
}
.private-group-message {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #cfcccc;
  height: max-content;
  width: 100%;
  color: black;
  padding: 20px 8px;
}

.private-group-message img {
  width: 50px;
  margin-bottom: 15px;
}

.private-group-message p {
  text-align: center;
  margin-bottom: 15px;
  font-size: 20px;
  letter-spacing: 1px;
}

#newsfeed-items-grid {
  width: 100%;
}

@media screen and (max-width: 1023px) {
  .left-bar{
    margin-right: unset;
    padding: 0 8px;
    min-width: 100%;
  }
  .right-bar {
    display: none;
  }
  .private-group-message {
  margin: 0 8px;
  }
}

@media (max-width: 719px) {
  .container {
    padding: 0;
  }
}

@media (max-width: 591px) {
  .left-bar {
    margin: auto;
  }
}
</style>

<style>
.private-group-message .join-group-btn .md-ripple {
  width: unset;
}
</style>
